import endpoint from "@/api/endpoint";
export default {
    all(){
        return window.axios.get(endpoint+'/api/student_groups');
    },
    create(data) {
        return window.axios.post(endpoint + '/api/student_groups/create', data);
    },

    delete(id) {
        return window.axios.post(endpoint + '/api/student_groups/'+id+'/delete');
    },
    users(data) {
        return window.axios.get(endpoint + '/api/student_groups/' + data.id + '/users');
    },

    criteria(data) {
        return window.axios.get(endpoint + '/api/student_groups/' + data.id + '/criteria');
    },

    rating() {
        return window.axios.get(endpoint + '/api/student_groups/rating');
    },

    getByDepartment(department_id) {
        return window.axios.get(endpoint + '/api/student_groups/by_department/' + department_id);
    }
}
